import React from 'react';

import { useSelector } from 'react-redux';

import { selectDashboard } from 'containers/Dashboard/selectors';
import { FindingsWithAreaChart } from 'containers/Dashboard/utils/FindingsWithAreaChart';

export const InfrastructurePostureFindings: React.FC = () => {
  const { cloudPostureOpenFindingsHistory } = useSelector(selectDashboard);

  return (
    <FindingsWithAreaChart
      history={cloudPostureOpenFindingsHistory.data}
      isLoadingChart={cloudPostureOpenFindingsHistory.isLoading}
      label="Critical and High Severity Issues"
    />
  );
};
